var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-overflow"},[_c('Navigation',{attrs:{"is-admin-view":true}}),_c('div',{staticClass:"ns-wrapper-top ns-wrapper"},[_c('DashboardNavigation'),_c('div',{staticClass:"padded-content"},[_c('div',{staticClass:"scrollable"},[_c('div',{staticClass:"ns-admin-wrapper"},[_c('router-view')],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }